import { render, staticRenderFns } from "./WinningNumbers.vue?vue&type=template&id=faf2e3d2&scoped=true&"
import script from "./WinningNumbers.vue?vue&type=script&lang=js&"
export * from "./WinningNumbers.vue?vue&type=script&lang=js&"
import style0 from "./WinningNumbers.vue?vue&type=style&index=0&id=faf2e3d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf2e3d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
